interface IGroup {
  id: string,
  childIds: string[],
}

interface INormalizedGroupSelection {
  groupIds: string[],
  childIds: string[],
}

// todo need to rethink approach with state synchronisation to avoid using this logic
const normalizeGroupSelection = (
  selectedChildIds: string[],
  groups: IGroup[],
): INormalizedGroupSelection => {
  const groupIds: string[] = [];
  const childIds: string[] = [];

  for (const group of groups) {
    const selectedInGroup = group.childIds.filter(
      (id) => selectedChildIds.includes(id),
    );

    const allChildrenSelected = selectedInGroup.length > 0
      && selectedInGroup.length === group.childIds.length;

    if (allChildrenSelected) {
      groupIds.push(group.id);
    } else {
      childIds.push(...selectedInGroup);
    }
  }

  return { groupIds, childIds };
};

export default normalizeGroupSelection;
